import React from "react";
import Icon from "../Icon";

const PaymentSuccess = () => {
  return (
    <div className="flex flex-col gap-4 xs:justify-between flex-grow">
      <div className="mb-4">
        <h2 className="font-inter text-2xl font-semibold">
          Payment Successful
        </h2>
      </div>

      <div className="flex items-center justify-center">
        <div className="border border-gray-300 rounded-xl py-4 flex flex-col gap-2 justify-center items-center w-3/5 mb-4">
          <Icon iconName="paymentSuccess" />
          <div className="flex">
            <div className="w-14 h-14 bg-blue-300"></div>
            <div className="w-14 h-14 bg-blue-300"></div>
            <div className="w-14 h-14 bg-blue-300"></div>
          </div>
          <p className="font-inter">$13,200</p>
          <p className="text-sm text-gray-500 font-inter">3 items, 12 yards</p>
        </div>
      </div>

      <div className="text-center">
        <p className="text-sm text-gray-500 font-inter">
          <span className="">
            Your payment for the Groom’s family Aso-ebi was successful! Your
            Order has successfully been sent. <br /> <br />
            You can reach out to{" "}
          </span>
          <span className="font-semibold">{`09076345678`}</span>
        </p>
      </div>

      <button className="mt-4 rounded-md text-white font-inter py-2 w-48 bg-[#34544F] hover:bg-[#4e7e77] mx-auto transition duration-300">
        Chat on whatsapp
      </button>
    </div>
  );
};

export default PaymentSuccess;
